import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=04d81f56&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=04d81f56&prod&scoped=true&lang=css"
import style1 from "./Templates.vue?vue&type=style&index=1&id=04d81f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d81f56",
  null
  
)

export default component.exports